import getView from '@/helpers/components/getView';
import getComponent from '@/helpers/components/getComponent';

export default [
  {
    path: '/Reports/Velocity/Generate',
    name: 'Velocity',
    component: getView('reports/velocity/Generate'),
  },
  {
    path: '/Reports/Velocity',
    component: getView('reports/velocity/Velocity'),
    children: [
      {
        path: '',
        name: 'Velocity-Global',
        component: getComponent('reports/velocity/Global'),
      },
      {
        path: ':projectName',
        name: 'Velocity-Details',
        component: getComponent('reports/velocity/ProjectDetails'),
      },
    ],
  },
  {
    path: '/Reports/VelocityAll',
    name: 'VelocityAll',
    component: getView('reports/velocity/VelocityAll'),
  },
  {
    path: '/Reports/PullRequest/Generate',
    name: 'PullRequest',
    component: getView('reports/pullRequests/Generate'),
  },
  {
    path: '/Reports/PullRequest',
    component: getView('reports/pullRequests/PullRequest'),
    children: [
      {
        path: '',
        name: 'PullRequest-Global',
        component: getComponent('reports/pullRequests/Global'),
      },
      {
        path: ':projectName',
        name: 'PullRequest-Details',
        component: getComponent('reports/pullRequests/ProjectDetails'),
      },
    ],
  },
  {
    path: '/Reports/PullRequestAll',
    name: 'PullRequestAll',
    component: getView('reports/pullRequests/PullRequestAll'),
  },
  {
    path: '/Reports/Bug/Generate',
    name: 'Bug',
    component: getView('reports/bugs/Generate'),
  },
  {
    path: '/Reports/Bug',
    component: getView('reports/bugs/Bug'),
    children: [
      {
        path: '',
        name: 'Bug-Global',
        component: getComponent('reports/bugs/Global'),
      },
      {
        path: ':projectName',
        name: 'Bug-Details',
        component: getComponent('reports/bugs/ProjectDetails'),
      },
    ],
  },
  {
    path: '/Reports/BugAll',
    name: 'BugAll',
    component: getView('reports/bugs/BugAll'),
  },
  {
    path: '/Reports/Availability/Generate',
    name: 'Availability',
    component: getView('reports/availability/Generate'),
  },
  {
    path: '/Reports/Availability',
    component: getView('reports/availability/Availability'),
    children: [
      {
        path: '',
        name: 'Availability-Global',
        component: getComponent('reports/availability/Global'),
      },
      {
        path: ':chargeToId',
        name: 'Availability-Details',
        component: getComponent('reports/availability/AvailabilityDetails'),
      },
    ],
  },
  {
    path: '/Reports/Activities/Generate',
    name: 'PreSaleAnalysisActivitiesGenerate',
    component: getView('reports/activities/Generate'),
  },
  {
    path: '/Reports/Activities',
    component: getView('reports/activities/PreSaleAnalysisActivities'),
    children: [
      {
        path: '',
        name: 'PreSaleAnalysisActivities',
        component: getComponent('reports/activities/PreSaleAnalysisActivities'),
      },
    ],
  },
  {
    path: '/Reports/WorkItemsExport/Generate',
    name: 'WorkItemsWordExportReportGenerate',
    component: getView('reports/workItemsExport/Generate'),
  },
];
